export default {"src":"/customer-services/_next/static/media/logo-partnership-card.ffdcd337.svg","height":13,"width":190,"blurWidth":0,"blurHeight":0};